import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../../theme';

export const useAdminAccountSelectorStyles = createStyles(() => ({
  selector: {
    width: 240,
    marginBottom: ThemeSpaces.SPACE_SM,

    '.ant-select-selection-item': {
      paddingRight: ThemeSpaces.SPACE_NORM_20,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
}));
